import React from "react";
import CustomModal from "../../reusable/CustomModal/CustomModal";

const CancelOrderModal = ({ visible, header, setVisible, footer, cancelOrder, isLoading }) => {
  return (
    <>
      <CustomModal
        visible={visible}
        title={header}
        onClose={setVisible}
        width={450}
        className="filter-modal"
        footer={footer}
      >
        <div className="my-5 pb-3">
          <div>
            <div className="text-center">
              <h4 className="my-4">Confirm Cancellation</h4>
            </div>
            <div className="m-3">
              <div className="text-center my-2">
                <h6 className="ad-text-primary">
                  Are you sure, You want to cancel the order?
                </h6>
              </div>
              <div className="d-flex justify-content-between mt-5">
                <button
                  type="button"
                  className="btn ad-bg-cyan button-border"
                  onClick={() => setVisible(false)}
                >
                  Don't Cancel
                </button>
                <button
                  type="button"
                  className="ad-bg-primary btn mx-3 ad-text-secondary "
                  onClick={() => cancelOrder()}
                >
                  {isLoading ? (
                    <div class="spinner-border" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  ) : (
                    "Cancel Order"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default CancelOrderModal;
